import { useQuery } from '@tanstack/react-query';
import { getLicenseDetails } from '@/lib/api';
import type { LicenseDetailResponse } from '@/types/api';
import { getStoredToken } from '@/features/auth/utils/authStorage';
import { licenseQueryKeys } from './useLicenseStatus';

export function useLicenseDetails() {
  return useQuery<LicenseDetailResponse>({
    queryKey: licenseQueryKeys.details(),
    queryFn: getLicenseDetails,
    staleTime: 60_000,
    enabled: !!getStoredToken(),
  });
}
